// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__cLM2H","phones":"Home_phones__noouj","phone":"Home_phone__-4FLc","iconWrapper":"Home_iconWrapper__ayw7r","number":"Home_number__Lya8A"};